// src/services/contactServices.ts
import apiClient from './apiClient';

export interface ContactMessagePayload {
  name: string;
  email: string;
  subject: string;
  message: string;
  recaptcha_token: string;
  formType: 'loggedin' | 'lp' | 'contact_page';
}

/**
 * お問い合わせメッセージを送信
 */
export const sendContactMessage = async (
  payload: ContactMessagePayload
): Promise<any> => {
  const res = await apiClient.post('/contact/', payload, {
    withCredentials: true,
  });
  return res.data;
};
